import { FC, useMemo } from 'react'

import RFFFields from '../../react-final-form-fields'

import { ITrainingCompliancePersonnelReportFormProps } from './training-compliance-personnel-report-form-types'
import { useTrainingGroupsQuery, useTrainingPeopleQuery } from '../../../../services'
import { Col, Row } from 'react-bootstrap'

const personnelLabel = 'Personnel'
const groupLabel = 'Personnel Group'

const TrainingCompliancePersonnelReportForm: FC<ITrainingCompliancePersonnelReportFormProps> = props => {
  const { handleSubmit, submitting, formName } = props

  const { data: trainingPeople, isFetching: isTrainingPeopleLoading } = useTrainingPeopleQuery({ activeOnly: true })
  const { data: trainingGroups, isFetching: isTrainingGroupsLoading } = useTrainingGroupsQuery({ activeOnly: true })

  const trainingPeopleOptions = useMemo(
    () => [
      { value: '', label: 'All Personnel' },
      ...(trainingPeople || []).map(person => ({
        value: person.id,
        label: person.displayName,
      })),
    ],
    [trainingPeople],
  )

  const trainingGroupsOptions = useMemo(
    () => [
      { value: '', label: 'All Personnel Groups' },
      ...(trainingGroups || []).map(group => ({
        value: group.id,
        label: group.displayName,
      })),
    ],
    [trainingGroups],
  )

  const { values } = props;
  return (
    <form onSubmit={handleSubmit} id={formName}>
      <Row>
        <Col>
          <RFFFields.Select
            name="personnelId"
            label={personnelLabel}
            options={trainingPeopleOptions}
            placeholder={'Select ' + personnelLabel}
            disabled={submitting || isTrainingPeopleLoading}
            value={values?.personnelId ?? ''}
          />
        </Col>
        <Col>
          <RFFFields.Select
            name="trainingGroupId"
            label={groupLabel}
            options={trainingGroupsOptions}
            placeholder={'Select ' + groupLabel}
            disabled={submitting || isTrainingGroupsLoading}
            value={values?.trainingGroupId ?? ''}
          />
        </Col>
      </Row>
    </form>
  )
}

export default TrainingCompliancePersonnelReportForm
